import { Grid, Text } from '@mantine/core';
import { PropsWithChildren } from 'react';

interface FormSwitch extends PropsWithChildren {
  label: string;
}

export const FormSwitch = (props: FormSwitch) => {
  const { label, children } = props;

  return (
    <>
      <Grid.Col span={10}>
        <Text>{label}</Text>
      </Grid.Col>
      <Grid.Col span={2}>{children}</Grid.Col>
    </>
  );
};
